/**
 * @module app.bdc.reports.exportLadditionCtrl
 *
 */
define(['angular', 'moment'], function(angular, moment) {


    function ExportLadditionCtrl(
        $scope,
        $rootScope,
        reportRoutingService,
        orderService,
        userService,
        marketService,
        ladditionService,
        exportService
    ) {
        var self = {};

        self.rds = $rootScope.user;
        self.drv = $rootScope.parent;

        self.orderForm = $rootScope.orderForm;

        if (!self.orderForm) {
            return $scope.goTo('/list');
        }

        self.orders = $rootScope.orders;
        self.reportRouting = reportRoutingService;
        self.marketService = marketService;
        self.exportService = exportService;

        /**
         * Get date fr format
         * @param  {String} date : YYYY-MM-DD
         * @return {String}
         */
        self.getDate = function getDate(date) {
            return date ? moment(date).format('DD/MM/YYYY') : '';
        };

        /**
         * Get date fr signature
         * @param  {String} date : YYYY-MM-DD
         * @return {String}
         */
        self.getMonthNumberDateSignature = function getMonthNumberDateSignature(date) {
            return date ? moment(date).format('M') : date;
        };

        /**
         * Get date installation
         * @param {String} date
         * @return {String}
         */
        self.getDateInstallation = function getDateInstallation(date) {
            return date
                ? moment(date, 'YYYY-MM-DD')
                    .format('MMMM YYYY')
                    .toUpperCase()
                : null;
        };

        /**
         * Get RDS to display
         * @param  {String} rdsRef
         * @return {String}
         */
        self.getRDS = function getRDS(rdsRef) {
            var rds = userService.findPerson(rdsRef);
            return rds ? rds.user.firstname + ' ' + rds.user.lastname : rdsRef;
        };

        /**
         * Get DRV to display
         * @param  {String} drvRef
         * @return {String}
         */
        self.getDRV = function getDRV(drvRef) {
            var drv = userService.findPerson(drvRef);
            return drv ? drv.user.firstname + ' ' + drv.user.lastname : drvRef;
        };

        /**
         * Find options according to types passed in parameters in a given option and populate those options with additionnal attributes from rootscope
         * @param  {Object} order
         * @param  {String} types Add each optionType to include in the result of the function as a parameter after the order
         * @return {Array} List of options matching the given optionTypes
         */
        self.getOptions = function getOptions(order) {
            // Join parameters together in an array, starting from index 1 to ignore the order (equivalent to ES6 rest parameters)
            var types = Array.prototype.slice.call(arguments, 1);
            // Parse orderForm to get missing options keys
            order.options.forEach(function(orderOption) {
                var optionInfos = $rootScope.orderForm.options.find(function(formOption) {
                    return formOption.id === orderOption.id;
                });
                // Add attributes to the options we will return at the end of the function
                orderOption.optionType = optionInfos ? optionInfos.optionType : '';
                orderOption.label = optionInfos ? optionInfos.label : '';
            });
            return order.options.filter(function(option) {
                for (var key in types) {
                    if (option.optionType.code === types[key]) {
                        return true;
                    }
                }
                return false;
            });
        };

        /**
         * Call ladditionService to get order total laddition prices
         * @param  {Object} order
         * @return {Object}       totalprice : {purchase: Number, rental: Number}
         */
        self.getTotalPrice = function getTotalPrice(order) {
            // Parse orderForm to get missing options keys
            order.options.forEach(function(orderOption) {
                var optionInfos = $rootScope.orderForm.options.find(function(formOption) {
                    return formOption.id === orderOption.id;
                });
                orderOption.optionType = optionInfos ? optionInfos.optionType : '';
                orderOption.reference = optionInfos ? optionInfos.reference : '';
                orderOption.prices = optionInfos ? optionInfos.prices : [];
            });
            order.laddition.options = ladditionService.getLadditionOptions(order.options);
            return ladditionService.calculateLadditionPrice(order.laddition);
        };

        self.displaySponsorInfos = function displaySponsorInfos(order) {
            if (order.sponsorName !== null) {
                return order.sponsorName;
            }
            else {
                return orderService.getSponsorInfos(order.sponsor).reduce(function(acc, curr, index) {
                    return acc + ' ' + (index % 2 == 1 ? curr + '</li>' : curr);
                }, '<li>');
            }
        };

        return self;
    }

    ExportLadditionCtrl.$inject = [
        '$scope',
        '$rootScope',
        'reportRoutingService',
        'orderService',
        'userService',
        'marketService',
        'ladditionService',
        'exportService'
    ];

    angular.module('app.bdc.reports.exportLadditionCtrl', []).controller('ExportLadditionCtrl', ExportLadditionCtrl);
});
